module.exports = __webpack_public_path__ + "static/media/noimage.84b77b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/noimage.png
// module id = 908
// module chunks = 0